import { module } from "angular";
import { EditButtonComponent } from "./EditButtonComponent";

module("mmGui").component("irEditButton", new EditButtonComponent());
